import aeLogo from '@images/home/logo-ae-white.svg';
import huluLogo from '@images/home/logo-hulu-white.svg';
import netflixLogo from '@images/home/logo-netflix-white.png';
import peacockLogo from '@images/home/logo-peacock-white.svg';
import rokuLogo from '@images/home/logo-roku-white.svg';

export type BrandPartnerLogo = {
  src: string;
  alt: string;
  height: number;
  maxWidth: number;
};

/** White partner marks from the design system (node 116:2492). */
const HOME_BRAND_PARTNER_LOGOS: Record<string, BrandPartnerLogo> = {
  honest: {
    src: rokuLogo,
    alt: 'Roku',
    height: 24,
    maxWidth: 66,
  },
  peacock: {
    src: peacockLogo,
    alt: 'Peacock',
    height: 28,
    maxWidth: 81,
  },
  netflix: {
    src: netflixLogo,
    alt: 'Netflix',
    height: 26,
    maxWidth: 81,
  },
  rachael: {
    src: huluLogo,
    alt: 'Hulu',
    height: 24,
    maxWidth: 62,
  },
  hoarders: {
    src: aeLogo,
    alt: 'A&E',
    height: 24,
    maxWidth: 39,
  },
};

export const getHomeBrandPartnerLogo = (
  partnerId: string,
): BrandPartnerLogo | undefined => HOME_BRAND_PARTNER_LOGOS[partnerId];
